var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('content', {
    staticClass: "livepage"
  }, [_c('lm-popup', {
    attrs: {
      "visible": _vm.modelVisible,
      "width": "350px",
      "contentText": _vm.popupText
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.modelVisible = $event;
      }
    },
    scopedSlots: _vm._u([{
      key: "footer",
      fn: function fn() {
        return [_c('div', {
          staticClass: "popup-bottom"
        }, [_c('div', {
          staticClass: "btn",
          on: {
            "click": _vm.goHome
          }
        }, [_vm._v("\n           " + _vm._s(_vm.$t('liveroom.intercept-model-btn')) + "\n         ")])])];
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('div', {
    staticClass: "liveroom-box"
  }, [_vm.allowed ? _c('liveroom', {
    ref: "liveroomModel",
    attrs: {
      "channel": _vm.channel,
      "authentication": _vm.authentication,
      "minimum": _vm.minimum
    },
    on: {
      "authenticate": _vm.authenticateHandler,
      "recharge": _vm.rechargeHandler,
      "nextchannel": _vm.nextChannelHandler,
      "messageCallBack": _vm.messageCallBack
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('recommendedlist', {
    attrs: {
      "channel": _vm.channel,
      "userInfo": {}
    },
    on: {
      "emitOnSkipLiveRoom": _vm.onSkipLiveRoom
    }
  }), _vm._v(" "), _c('loginReg', {
    ref: "logReg",
    attrs: {
      "success": _vm.successHandle,
      "logout": _vm.logoutHandle
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };